import { getFullTranslations } from './util';

export const deTranslationMessages = getFullTranslations('de');
